import React from 'react'
import PropTypes from 'prop-types'

import './code.scss'

class CodeComponent extends React.Component {
    render() {
        const { title, titleClassName, code, type } = this.props
        return <div className={`code ${type}`}>
            {title && <p
                className={titleClassName}
                dangerouslySetInnerHTML={{ __html: title }}
            />}
            <pre>
                {code}
            </pre>
        </div>
    }
}

CodeComponent.defaultProps = {
    titleClassName: '',
    type: '',
}

CodeComponent.propTypes = {
    title: PropTypes.string,
    titleClassName: PropTypes.string,
    code: PropTypes.string.isRequired,
    type: PropTypes.string,
}

export default CodeComponent



// WEBPACK FOOTER //
// ./src/components/core/CodeComponent/CodeComponent.js